import { supabase } from "@/integrations/supabase/client";

export interface CoverLetterHeaderInfo {
  fullName: string;
  phoneNumber: string;
  email: string;
  cityST: string;
  linkedin: string;
  companyName: string;
  recipientName: string;
  jobTitle?: string;
}

export interface CoverLetterData {
  headerInfo: CoverLetterHeaderInfo;
  letterBody: string;
  templateUrl?: string;
}

export class CoverLetterService {
  static async generateCoverLetter(data: CoverLetterData): Promise<Blob> {
    try {
      console.log('Generating cover letter:', {
        hasHeaderInfo: !!data.headerInfo,
        hasLetterBody: !!data.letterBody,
        companyName: data.headerInfo.companyName,
        jobTitle: data.headerInfo.jobTitle
      });

      const response = await fetch(`https://gxatnnzwaggcvzzurgsq.supabase.co/functions/v1/generate-cover-letter`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd4YXRubnp3YWdnY3Z6enVyZ3NxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2MTQzMzMsImV4cCI6MjA2ODE5MDMzM30.btK3YXr_f0uPm_mwT5q9-8U3d10_QMevDSlC2NSZO_I`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error calling generate-cover-letter function:', errorText);
        throw new Error(`Cover letter generation failed: ${response.status} - ${errorText}`);
      }

      // Check content type to ensure we got a document
      const contentType = response.headers.get('content-type');
      console.log('Response content-type:', contentType);

      if (contentType && contentType.includes('application/json')) {
        // If we got JSON, it's likely an error response
        const errorData = await response.json();
        console.error('Received JSON error response:', errorData);
        throw new Error(errorData.error || 'Unexpected JSON response instead of document');
      }

      // Return the response as a blob
      const blob = await response.blob();
      console.log('Generated blob size:', blob.size, 'bytes');
      
      return blob;

    } catch (error) {
      console.error('Error in CoverLetterService.generateCoverLetter:', error);
      throw new Error(
        error instanceof Error 
          ? error.message 
          : 'Failed to generate cover letter'
      );
    }
  }

  static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}